// export { counter } from './example.counter'
// export { photos } from './example.photos'
// export { photo } from './example.photo'
// export { posts } from './example.posts'
// export { post } from './example.post'

// export { products } from './example.products'
// export { cart } from './example.cart'
// export { checkout } from './example.checkout'
// export { user } from './example.user'
export { modals } from './example.modals'

export { page } from './page'
export { project } from './project'
export { projects } from './projects'
export { categories } from './categories'




// WEBPACK FOOTER //
// ./src/redux/models/index.js